<template>
  <div
    class="text-caption text-secondary--text"
    data-qa="practice_updated_date"
  >
    Данные обновлены {{ context.doctor_practice.dt_updated }}
  </div>
</template>

<script lang="ts" setup>
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

const { context }: ContextStore = useContextStore()
</script>
